<template>
	<div id='depreciationSummary'>
		<div class="public-content">
			<div class="form-item-public">
				<el-form inline>
					<el-form-item label="折旧汇总表">
					    <el-date-picker
						type="month"
						size="mini"
						placeholder="选择月"
						v-model='date.start'
						:picker-options = 'pickerBeginDateBefore'
						@change="dateChange($event, 'start')"
						format="yyyy 年 MM 月" style='width: 140px;'>
					    </el-date-picker>
					    <span>至</span>
					    <el-date-picker
						type="month"
						size="mini"
						v-model='date.end'
						@change="dateChange($event, 'end')"
						:picker-options='pickerBeginDateAfter'
						placeholder="选择月"
						format="yyyy 年 MM 月" style='width: 140px;'>
					    </el-date-picker>
				    </el-form-item>
				    <el-form-item>
				    	<el-button size='mini' class='minButton' @click='setTableConfig'>搜索</el-button>
				    </el-form-item>
				</el-form>
			</div>
			<!-- 表格 -->
			<public-table :table='tableData'></public-table>
		</div>
	</div>
</template>
<script>
	import {currencys} from '@/assets/utils/currencyFormat'
	import publicTable from '@/components/publicTable'
	export default {
		components: {
			publicTable
		},
		data() {
			return {
				isFirstActive: false,
				pickerBeginDateBefore: {
					disabledDate: (time)=>{
						 let startVal = this.getAccountPeriod.startTimeStamp;
						 let endVal = this.getAccountPeriod.endTimeStamp;
						 if(startVal && endVal) {
						 	return time.getTime() < startVal || time.getTime() > endVal
						 }
					}
				},
				pickerBeginDateAfter: {
					disabledDate: (time)=>{
						let startYear = new Date(this.date.start);
						let endYear = startYear ? new Date(startYear.getFullYear()+1, 0) : ''
						let startVal = this.getAccountPeriod.startTimeStamp;
						let endVal = this.getAccountPeriod.endTimeStamp;
						if(startYear) {
							return time.getTime() < startYear || time.getTime() >=endYear || time.getTime() > endVal
						}else{
							if(startVal && endVal) {
							 	return time.getTime() < startVal || time.getTime() > endVal
							 }
						} 
					}
				},
        config: [{
						label: '类别',
						value: 'genresName',
						show: 'normal',
					},{
						label: '原值',
						value: 'resourceAssets',
						width: 140,
						formatter: this.formatter,
						show: 'normal'
					},{
						formatter: this.formatter,
						label: '期末累计折旧',
						value: 'endDepreciation',
						width: 120,
						show: 'normal'
					},{
						label: '减值准备',
						formatter: this.formatter,
						value: 'depreciationReserves',
						show: 'normal'
					},{
						label: '期末净值',
						value: 'endNetvalue',
						formatter: this.formatter,
						width: 120,
						show: 'normal'
					}],
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					key: 0,						// 渲染
					config: this.config,
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
				},
				date: {
					start:'',           // 当前选择开始日期
					end: '',			// 当前选择结束日期
				},
				form: {							// 筛选条件
					startperiods: '',			// 开始周期（月）
					endperiods: '',				// 结束周期（月）
					type: 'depreciationsum',	// 折旧汇总
					selectYear: ''				// 当前年
				},
			}
		},
		created() {
			this.getAccountPeriods();
		},
		computed: {
			getAccountPeriod() {
				return this.$store.state.accountInfo.yearPeriods;
			},
			getClickCache() {
				return this.$store.state.loadstatus.isClickCache;
			},
		},
		activated() {
			if(this.getClickCache && this.isFirstActive) {
				this.getAccountPeriods();
			}
			this.isFirstActive = true;
		},
		methods: {
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}

			},
			// 选择会计期间
			dateChange (val, name) {
				if (name == 'start') {
					this.form = Object.assign({}, this.form, {
						startperiods: this.$util.formatDate.format(val, 'MM'),
						endperiods: this.$util.formatDate.format(val, 'MM')
					})
					this.date = Object.assign(this.date, {
						start: val,
						end: val
					})
				} else {
					this.$set(this.form, 'endperiods', this.$util.formatDate.format(val, 'MM'));
				}
				this.form.selectYear = this.$util.formatDate.format(val, 'yyyy');
			},
			// 获取会计期间/初始化数据	
			getAccountPeriods() {
				let accountInfo = this.$getSessionStorage('accountInfo')
				if(!this.getAccountPeriod) {
					this.$store.dispatch('getAllYearPeriodsData')
				}
				this.date = Object.assign(this.date,{
					start: accountInfo.yearPeriodTimeStamp,
					end: accountInfo.yearPeriodTimeStamp,
				})
				
				this.form = Object.assign(this.form , {
					startperiods: this.$util.formatDate.format(this.date.start , 'MM'),
					endperiods: this.$util.formatDate.format(this.date.end , 'MM'),
					selectYear: this.$util.formatDate.format(this.date.start , 'yyyy'),
				})
				this.setTableConfig();
			},
      // 设置表头
			setTableConfig () {
        const fullYear = new Date(this.date.start).getFullYear();
				let data = {
					month: [ '01期', '02期', '03期', '04期', '05期', '06期', '07期', '08期', '09期', '10期', '11期', '12期'],
					value: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'december']
				}
        data.month = data.month.map(i=> (fullYear + i))
				let defaultConfig = [];
				let monthConfig = [];
				let startConfig = [];
				let endConfig = [];
				let mergeConfig = [];
				let startMonth = Number(this.form.startperiods.replace(/^0+/, ''));
				let endMonth = Number(this.form.endperiods.replace(/^0+/, ''));
				if (this.form.startperiods && this.form.endperiods) {
					this.$set(this.tableData, 'config', this.config);

					// 如果开始时间等于结束时间
					if (this.form.startperiods == this.form.endperiods) {
						monthConfig.push({
							label: data.month[startMonth-1],
							value: data.value[startMonth-1],
							show: 'normal',
							type: 'month',
							formatter: this.formatter
						})
					}
					// 如果开始时间小于结束时间
					if (this.form.startperiods < this.form.endperiods) {
						for (let i = startMonth-1; i < endMonth; i++) {
							monthConfig.push({
								label: data.month[i],
								value: data.value[i],
								show: 'normal',
								type: 'month',
								formatter: this.formatter
							})
						}
					}
					if (monthConfig.length) {

						defaultConfig = this.tableData.config.filter((item, index) => {
							return item.value 
						})

						startConfig = defaultConfig.slice(0, 2);
						endConfig = defaultConfig.slice(2);
						
						this.tableData.config = mergeConfig.concat(startConfig, monthConfig, endConfig).map(item => {
								if (item.value == 'currentEndDepreciation') {
									item.label = `${this.form.selectYear}年${this.form.startperiods}-${this.form.endperiods}期期末累计折旧`;
									item.show = 'normal';
								}
								return item;
						});
					}
				} else {
					this.$notify.error('请选择正确的期间!');
					return;
				}

				this.getDepreciationsum();
			},
			// 获取折旧汇总表格数据
			getDepreciationsum() {
				try {
					this.tableData.loading = true;
					this.$http.post('assets/findDetail',this.form).then(res=>{
						this.tableData.data = res.data.data;
						 this.tableData.loading = false;

					})
				}catch(e){
					
				}finally{
					this.tableData.loading = false;
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>
	
</style>


// WEBPACK FOOTER //
// src/pages/assets/depreciationSummary.vue